import { createSelector } from 'reselect';
import { prepareMenuForOrdering, validateCartItem, calcCartItemPrice, checkTypes } from '../helpers/menu-helpers';

const getOrderType = state => state.order.cart.orderType;
const getCatalog = state => state.catalog;
const getUpsells = state => state.catalog.upsells;
const getLanguage = state => state.app.language;
const getItemInConstruction = state => state.order.itemInConstruction;

export const getMenu = createSelector(
    [getCatalog, getOrderType, getLanguage],
    (catalog, orderType, language) => {
        const customerType = 'default';
        const translations = catalog && catalog.translations ? catalog.translations[language] : {};
        return prepareMenuForOrdering(catalog || {}, { customerType, orderType, spreadCategoriesParents: true, translations });
    }
);

export const calcItemInConstruction = createSelector(
    [getMenu, getItemInConstruction],
    (menu, cartItem) => {
        const missingSelection = validateCartItem(menu.catalog, cartItem);
        const isValid = !missingSelection;
        const finalPrice = calcCartItemPrice(menu.catalog, cartItem);
        const editMode = cartItem.index !== undefined;
        // TODO: indicate on invalid category

        return { isValid, finalPrice, editMode, missingSelection };
    }
);

export const getActiveUpsell = createSelector(
    [getMenu, getUpsells, getOrderType],
    (menu, upsells, orderType) => {
        const upsellsCategories = Object.keys(upsells).reduce((results, trigger) => {
            const upsell = upsells[trigger];

            if (upsell.triggerStatus === 'active') {
                upsell.categories.forEach(c => {
                    const category = menu.catalog.categories[c.id];
                    if (category && checkTypes(category, orderType)) {
                        const items = c.itemsInstances.map(i => menu.catalog.items[i.id]).filter(item => checkTypes(item, orderType));

                        if (items.length) results.push({ trigger, items, title: category.description });
                    }
                });
            }

            return results;
        }, []);

        return upsellsCategories[0];
    }
);